import React from "react";
import { Box } from "@mui/material";
import TeamSection from "../../components/TeamSection";
import ContactForm from "../../components/ContactForm";

const AboutUs = () => {
  return (
  <Box sx={{ width: "100%", bgcolor: "#fff" }}>
    <TeamSection/>
    <ContactForm/>
  </Box>
  );
};

export default AboutUs;
